var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    label: "원료명",
                    name: "title",
                  },
                  model: {
                    value: _vm.searchParam.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "title", $$v)
                    },
                    expression: "searchParam.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    editable: _vm.editable,
                    comboItems: _vm.useFlagItems,
                    label: "사용여부",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "useFlag",
                    type: "search",
                  },
                  model: {
                    value: _vm.searchParam.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "useFlag", $$v)
                    },
                    expression: "searchParam.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
          [
            _c(
              "c-table",
              {
                ref: "table",
                attrs: {
                  title: "원료 목록",
                  tableId: "table",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.grid.height,
                  data: _vm.grid.data,
                  columnSetting: false,
                },
                on: { linkClick: _vm.linkClick },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: { label: "검색", icon: "search" },
                          on: { btnClicked: _vm.getList },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
          [
            _c(
              "c-card",
              { staticClass: "cardClassDetailForm", attrs: { title: "상세" } },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: { label: "신규", icon: "add" },
                            })
                          : _vm._e(),
                        _c("c-btn", { attrs: { label: "저장", icon: "save" } }),
                        _c("c-btn", {
                          attrs: { label: "삭제", icon: "remove" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-plant", {
                        attrs: { type: "edit", name: "plantCd" },
                        model: {
                          value: _vm.data.col1,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "col1", $$v)
                          },
                          expression: "data.col1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("c-text", {
                        attrs: {
                          editable: _vm.editable,
                          required: true,
                          label: "원료명",
                          name: "sequenceNm",
                        },
                        model: {
                          value: _vm.data.col2,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "col2", $$v)
                          },
                          expression: "data.col2",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-select", {
                        attrs: {
                          codeGroupCd: "WEIGHT_UNIT",
                          type: "edit",
                          itemText: "codeName",
                          itemValue: "code",
                          name: "col3",
                          label: "단위",
                        },
                        model: {
                          value: _vm.data.col3,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "col3", $$v)
                          },
                          expression: "data.col3",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-radio", {
                        attrs: {
                          editable: _vm.editable,
                          comboItems: _vm.useFlagItems,
                          label: "사용여부",
                          name: "col4",
                        },
                        model: {
                          value: _vm.data.col4,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "col4", $$v)
                          },
                          expression: "data.col4",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }